import { useSearchParams } from 'react-router-dom'

import { resolveFakeDoorType } from './resolver'
import { fakeDoorViews } from './views'

export const FakeDoor = () => {
  const [searchParams] = useSearchParams()

  const type = resolveFakeDoorType(searchParams.get('type'))

  const FakeDoorView = fakeDoorViews[type]

  return <FakeDoorView />
}
